
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"16","viewBox":"0 0 21 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.308 15.674l7.845-7.13c.33-.301.33-.786 0-1.087L12.308.326a1.313 1.313 0 00-1.732 0 1.044 1.044 0 000 1.573L17.287 8l-6.71 6.1a1.045 1.045 0 000 1.574 1.313 1.313 0 001.73 0z","fill":"#000"}}),_c('path',{attrs:{"stroke":"#000","stroke-width":"2","stroke-linecap":"round","d":"M1 8h18"}})])
          )
        }
      }
    